<template>
  <div class="container top-level-div">
    <div class="content-block">
      <h1 ref="pageTitle">Contact Us</h1>
      <hr>
      <h4 class="">Comment? Question? Would you like to explore ways to work together? We'd love to hear from you!</h4>

      <div class="mt-4">
        <input type="text" class="form-control" placeholder="Name" v-model="name">
        <input type="text" class="form-control mt-2" placeholder="Email" v-model="email">
        <input type="text" class="form-control mt-2" placeholder="Organization (if applicable)" v-model="organization">
        <textarea class="form-control mt-2" rows="6" placeholder="Message" v-model="message"></textarea>
        <button class="mylisting-button dark-button" @click="submitMessage()">Submit</button>

        <h4 v-if="submitted" class="mt-3">Thank you for your message! Someone from the ThriveHire team will be in touch with you shortly.</h4>
      </div>

      <h4 class="mt-5">Come Visit Us!</h4>
      <p>KHS45-40 Gould Street</p>
      <p>Toronto, ON</p>
      <p>M5B1E9</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '',
      email: '',
      organization: '',
      message: '',

      submitted: false,
    }
  },
  created() {
    // Scroll the window up
    window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
  mounted() {
      document.title = this.$refs.pageTitle.innerHTML
    },
  methods: {
    submitMessage() {
      this.$store.dispatch('sendEmail',
        {
          subject: 'Contact Form Submission',
          message: 'New contact form submission!\n\n'+'Name: '+this.name+'\nEmail: '+this.email+'\nOrganization: '+this.organization+'\nMessage: '+this.message,
          // from: 'info@thrivehire.co',
          from: 'contactform@thrivehire.co',
          email: 'aakash@enginehire.ca',
          reply: 'info@thrivehire.org',
          userID: 4,
        }
      )
      this.$store.dispatch('sendEmail',
        {
          subject: 'Contact Form Submission',
          message: 'New contact form submission!\n\n'+'Name: '+this.name+'\nEmail: '+this.email+'\nOrganization: '+this.organization+'\nMessage: '+this.message,
          // from: 'info@thrivehire.co',
          from: 'contactform@thrivehire.co',
          // email: 'aakash@enginehire.ca',
          email: 'info@thrivehire.org',
          reply: 'info@thrivehire.org',
          userID: 4,
        }
      )
      this.submitted = true
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/general/Contact.vue